import { createContext, useContext } from 'react';
export const ScrollContainerRefContext = createContext(null);
ScrollContainerRefContext.displayName = 'ScrollContainerRefContext';
export const useScrollContainerRef = () => {
    const context = useContext(ScrollContainerRefContext);
    if (!context) {
        throw new Error('useScrollContainerRef must be used within a ScrollContainerRefProvider');
    }
    return context;
};
//# sourceMappingURL=ScrollContainerRefProviderShared.js.map